import React from 'react';
import { useT } from '@repo/common';

const EmptyWorkshop = () => {
  const t = useT();
  return (
    <div className='flex flex-col justify-center items-center tabletH:p-10 h-[180px] tabletH:h-[380px]'>
      <div className='tabletH:pb-6 w-[570px] flex items-center justify-center text-text-placeholder'>
        {t('No workshop yet', '아직 참여한 워크숍이 없습니다')}
      </div>
    </div>
  );
};

export default EmptyWorkshop;
